import buildRoute from './buildRoute'

export const getManufacturerDTC = async (
    active: boolean,
    manufacturerId: string
) => {
    try {
        let res: any
        res = await buildRoute({
            type: 'post',
            route: 'getManufacturersDTC',
            data: { active, manufacturerId },
        })
        if (res.data) {
            return res.data
        }
    } catch (err: any) {
        return console.error(err)
    }
}

export const addManufacturerDTC = async (formData: any) => {
    try {
        let res: any
        res = await buildRoute({
            type: 'post',
            route: 'manufacturerDTC',
            data: formData,
        })
        if (res.data) {
            return res
        }
    } catch (err: any) {
        console.error(err)
        return err
    }
}

export const addSingularManufacturerDTC = async (formData: any) => {
    try {
        let res: any
        res = await buildRoute({
            type: 'post',
            route: 'singleDTC',
            data: formData,
        })
        if (res.data) {
            return res
        }
    } catch (err: any) {
        console.error(err)
        return err
    }
}

const manufacturerDTCRoutes = {
    getManufacturerDTC,
    addManufacturerDTC,
    addSingularManufacturerDTC,
}

export default manufacturerDTCRoutes
